<template>
    <div>
        <!-- Tabla de detalles de costos -->
        <div class="panel">
            <b-table 
                :data="details" 
                :loading="isLoadingTable" 
                paginated 
                :per-page="perPage"
                :total="total" 
                @page-change="onPageChange" 
                :default-sort="orderField"
                :default-sort-direction="orderDir" 
                @sort="onSort" 
                class="w-full" 
                striped 
                bordered 
                icon-pack="fas">
                <template>
                    <b-table-column field="code" :label="$t('code')" sortable v-slot="props">
                        {{ props.row.code }}
                    </b-table-column>
                    <b-table-column field="description" :label="$t('description')" sortable v-slot="props">
                        {{ props.row.description }}
                    </b-table-column>
                    <b-table-column field="quantity" :label="$t('quantity')" sortable v-slot="props">
                        {{ props.row.quantity === 0 ? "-" : props.row.quantity }}
                    </b-table-column>
                    <b-table-column field="price" :label="$t('price')" sortable v-slot="props" centered>
                        {{ formatNumber(props.row.price) }}
                    </b-table-column>
                    <b-table-column field="import" :label="$t('total')" sortable v-slot="props" centered>
                        {{ formatNumber(props.row.price * props.row.quantity) }}
                    </b-table-column>
                    <b-table-column :label="$t('actions')" field="actions" centered width="150" v-slot="props">
                        <div class="w-full h-full flex items-center justify-around">
                            <b-tooltip :label="$t('edit')" position="is-left">
                                <div @click="editButtonClicked(props.row)" class="cursor-pointer flex text-blue">
                                    <b-icon pack="fas" icon="pencil-alt" />
                                </div>
                            </b-tooltip>
                            <b-tooltip :label="$t('remove')" position="is-left" type="is-danger">
                                <div @click="removeDetail(props.row)" class="cursor-pointer flex text-red">
                                    <b-icon pack="fas" icon="trash-alt" />
                                </div>
                            </b-tooltip>
                        </div>
                    </b-table-column>
                </template>
                <template #empty>
                    <div class="has-text-centered">{{ $t('no_results') }}</div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        projectId: {
            type: Number,
            required: true
        },
        type: {
            type: Number,
            required: true,
        }
    },
    computed: {
        filters() {
            return {
                per_page: this.perPage,
                page: this.page,
                project_id: this.projectId,
                type: this.type 
            };
        },
    },
    data() {
        return {
            isLoadingTable: true,
            details: [],
            perPage: 25,
            orderField: 'code',
            orderDir: 'asc',
            page: 1,
            total: 0,
        };
    },
    methods: {
        formatNumber(value) {
            return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        async getDetails(filters = null) {
            this.isLoadingTable = true;
            try {
                const params = filters || this.filters;
                const url = '/api/v2/cost-details'; 
                const response  = await axios.get(url, { params });
                if (response && response.data) {
                    this.details = response.data.data;
                    this.total   = response.data.meta.total;
                    this.$emit('total-price', response.data.meta.total_price);
                    this.$emit('name-cost', response.data.meta.cost_name);
                }
            } catch (error) {
                console.error('Error fetching details:', error);
            } finally {
                this.isLoadingTable = false;
            }
        },
        onSort(field, order) {
            this.orderField = field;
            this.orderDir = order;
        },
        onPageChange(page) {
            this.page = page;
        },
        async editButtonClicked(detail) {
            this.$emit('epc-edit', detail);
        },
        async removeDetail(detail) {
            this.$dialog.confirm({
                title: this.$t('delete'),
                message: this.$t('delete_confirm_text', [detail.description]),
                confirmText: this.$t('delete'),
                type: 'is-danger',
                hasIcon: true,
                onConfirm: async () => {
                    try {
                        const url = `/api/v2/cost-details/${detail.id}`;
                        const { data } = await axios.delete(url);
                        if (data.success) {
                            this.$toast.open({
                                message: this.$t('removed_successfully'),
                                type: 'is-success',
                                position: 'is-top-right'
                            });
                            this.$emit('reload-list');
                        } else {
                            this.$toast.open({
                                message: this.$t('remove_error'),
                                type: 'is-danger',
                                position: 'is-top-right'
                            });
                        }
                    } catch (error) {
                        console.error('Error removing detail:', error);
                    }
                }
            });
        },
        reload(args = {}) {
            const filters = { ...args, ...this.filters };
            this.getDetails(filters);
        }
    },
  
};
</script>

<style lang="scss" scoped>
table {
    border-collapse: none;
}
table td,
.table th {
    border: 1px solid #E2E8F0;
    padding: 0.5em 0.75em;
    text-align: center;
}
.table th {
    background-color: #4A5568;
    color: #FFFFFF;
}
</style>
